import { DlVault } from 'types/contracts';

export interface GetAllUsersInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetAllUsersOutput = {
  users: string[];
  count: number;
};

const getAllUsers = async ({
  dlVaultContract,
  accountAddress,
}: GetAllUsersInput): Promise<GetAllUsersOutput> => {
  const users = await dlVaultContract.methods
    .getAllUsers(accountAddress)
    .call();

  return {
    users: Array.isArray(users) ? users : [],
    count: Array.isArray(users) ? users.length : 0,
  };
};

export default getAllUsers; 